import React, { useState, useEffect } from 'react';
import guLocale from "../locales/gu";

const Footer = () => {
  const locale = guLocale.footer;
  const [currentYear, setCurrentYear] = useState('');

  useEffect(() => {
    const year = new Date().getFullYear();
    setCurrentYear(year.toString());
  }, []);

  return (
    <div>
      <footer className="main-footer">
        Copyright © {currentYear} All rights Reserved.
        <div className="float-right d-none d-sm-inline-block">
          <b>{locale.versionLabel}</b> {locale.versionNumber}
        </div>
      </footer>
      <aside className="control-sidebar control-sidebar-dark"></aside>
    </div>
  );
};

export default Footer;
